import React from 'react';
import Webcam from 'react-webcam';
import {Button, FormControl, InputLabel, NativeSelect} from '@material-ui/core';

export default function Camera({
  webcamRef,
  capturePhoto,
  emotion,
  handleEmotionChange,
  canEdit
}) {
  return !canEdit ? null : (
    <div style={{display: "flex", flex: 1, justifyContent: "center", margin: "1rem"}}>
      <div>
        <div>
          <Webcam
            style={{maxWidth:'100%'}}
            ref={webcamRef}
            audio={false}
            imageSmoothing={false}
            mirrored={true}
            screenshotFormat="image/jpeg"
            screenshotQuality={0.8}
            onUserMediaError={() => {
              // TODO: handle on camera error
            }}
          />
        </div>
        <div style={{paddingTop: "1rem", display: "flex", justifyContent: "space-evenly", alignItems:"center"}}>
          <FormControl>
            <InputLabel>Emotion</InputLabel>
            <NativeSelect
              value={emotion}
              onChange={handleEmotionChange}
              inputProps={{name: 'emotion', id: 'emotion-native-select'}}
            >
              <option value='Angry'>Angry</option>
              <option value='Annoyed'>Annoyed</option>
              <option value='Ecstatic'>Ecstatic</option>
              <option value='Happy'>Happy</option>
              <option value='Neutral'>Neutral</option>
              <option value='Pleased'>Pleased</option>
              <option value='Sad'>Sad</option>
              <option value='Scared'>Scared</option>
              <option value='Surprised'>Surprised</option>
            </NativeSelect>
          </FormControl>
          <FormControl>
            <Button variant="contained" color="primary" onClick={capturePhoto}>
              Capture
            </Button>
          </FormControl>
        </div>
      </div>
    </div>
  );
}
